module.exports = "<div id=\"msg-dlg\">\r\n  <p-messages [value]=\"msgs\"></p-messages>\r\n</div>\r\n"